module.exports = __webpack_public_path__ + "img/65.57f9d5da.jpg";